<script setup>
import { computed, ref } from 'vue';
import CloudWhatsapp from './CloudWhatsapp.vue';
import WhatsappEmbeddedSignup from './WhatsappEmbeddedSignup.vue';
import { useAccount } from 'dashboard/composables/useAccount';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { META_RESTRICTION_STATUS_URL } from 'dashboard/constants/globals';

const {
  isCloudFeatureEnabled,
  isOnChatwootCloud,
  isMetaInboxCreationDisabled,
} = useAccount();

const showManualSetup = ref(false);

const hasWhatsappAppId = computed(() => {
  return (
    window.chatwootConfig?.whatsappAppId &&
    window.chatwootConfig.whatsappAppId !== 'none'
  );
});

const isWhatsappEmbeddedSignupDisabled = computed(
  () => isMetaInboxCreationDisabled.value
);

const isWhatsappEmbeddedSignupFeatureEnabled = computed(
  () =>
    !isOnChatwootCloud.value ||
    isCloudFeatureEnabled(FEATURE_FLAGS.WHATSAPP_EMBEDDED_SIGNUP_FLOW)
);

const shouldShowWhatsappEmbeddedSignup = computed(
  () =>
    !showManualSetup.value &&
    hasWhatsappAppId.value &&
    isWhatsappEmbeddedSignupFeatureEnabled.value
);

const handleManualLinkClick = () => {
  showManualSetup.value = true;
};
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <div class="h-full w-full overflow-auto p-4 sm:p-6">
    <div class="mx-auto max-w-3xl">
      <div v-if="shouldShowWhatsappEmbeddedSignup">
        <WhatsappEmbeddedSignup
          :is-disabled="isWhatsappEmbeddedSignupDisabled"
          :show-restriction-alert="isWhatsappEmbeddedSignupDisabled"
          :restriction-status-url="META_RESTRICTION_STATUS_URL"
        />

        <details
          class="mt-6 border-t border-n-weak pt-4 text-sm text-n-slate-11"
        >
          <summary class="cursor-pointer font-medium text-n-slate-12">
            Precisa conectar com credenciais?
          </summary>
          <p class="mt-2 mb-3 leading-6">
            Se sua equipe técnica já tem os dados de uma conexão oficial, você
            pode informá-los manualmente.
          </p>
          <button
            type="button"
            class="font-medium text-n-brand underline"
            @click="handleManualLinkClick"
          >
            Abrir configuração manual
          </button>
        </details>
      </div>

      <CloudWhatsapp v-else />
    </div>
  </div>
</template>
